import { render, staticRenderFns } from "./ProcFlowModal.vue?vue&type=template&id=60120091&scoped=true&"
import script from "./ProcFlowModal.vue?vue&type=script&lang=js&"
export * from "./ProcFlowModal.vue?vue&type=script&lang=js&"
import style0 from "./ProcFlowModal.vue?vue&type=style&index=0&id=60120091&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60120091",
  null
  
)

export default component.exports